/**
 * FavoritesStack
 * Je favoriete spulletjes
 */

import React from 'react';
import {createNativeStackNavigator} from '@react-navigation/native-stack';
import {useTranslation} from 'react-i18next';
import {
  FavoritesScreen,
  ProductDetailScreen,
  AlternativesScreen,
} from '../screens';
import type {FavoritesStackParamList} from '../models/Navigation';

const Stack = createNativeStackNavigator<FavoritesStackParamList>();

export const FavoritesStackNavigator: React.FC = () => {
  const {t} = useTranslation();

  return (
    <Stack.Navigator id={undefined}>
      <Stack.Screen
        name="Favorites"
        component={FavoritesScreen}
        options={{
          title: t('favorites.title') || 'Favorieten',
          headerShown: true,
        }}
      />
      <Stack.Screen
        name="ProductDetail"
        component={ProductDetailScreen}
        options={{
          title: t('product.title') || 'Product',
          headerShown: false,
        }}
      />
      <Stack.Screen
        name="Alternatives"
        component={AlternativesScreen}
        options={{
          title: t('alternatives.title') || 'Alternatieven',
          headerShown: true,
        }}
      />
    </Stack.Navigator>
  );
};
